import { type ReactNode } from 'react';

import { CardChatButtonResponsiveContainer } from '../../CardChatButtonResponsiveContainer';
import { CardContactsButtonMobileContainer } from '../../CardContactsButtonContainer';
import { ContentActionsLayoyt } from '../components/ContentActionsLayoyt';

export function ContentActionsContainer(): ReactNode {
  return (
    <ContentActionsLayoyt>
      <CardContactsButtonMobileContainer />
      <CardChatButtonResponsiveContainer />
    </ContentActionsLayoyt>
  );
}
